import React, { useEffect } from 'react';
import { Flex, Text } from "@chakra-ui/layout";
import { Badge, Grid, Image, Link, Button } from "@chakra-ui/react";
import Doc from "../../../images/teacher/doc.svg";
import { useSelector } from 'react-redux';
import { getStudentAssignments } from '../../../action/studentAction';
import { useStudentAuthDispatch, StateType } from '../../../store/store';
import { NavLink } from 'react-router-dom';

function Assignments() {
  const dispatch = useStudentAuthDispatch();
  const { data: { token }, assignments: { assignments } } = useSelector((state: StateType) => state.rootReducer.studentReducer);
  const studentToken = token.includes("Bearer") ? token.slice(17, (token.length - 2)) : token.slice(10, (token.length - 2));

  useEffect(() => {
    dispatch(getStudentAssignments(studentToken));
  }, []);

  return (
    <Flex flexDirection={"column"} boxShadow="2xl" m={7} p={5} borderRadius={"20px"}>
      <Flex justifyContent="space-between">
        <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"2xl"}>Assignments</Text>
        <Link as={NavLink} to="/student/assignments/submitted" bgColor="blue.500" alignSelf="center" p="2"
          borderRadius="20px" _hover={{ textDecoration: "none", color: "green" }}>
          submitted assignments
        </Link>
      </Flex>
      <Grid gridTemplateColumns={"repeat(auto-fit, minmax(200px, 250px))"} justifyContent={"center"}>
        {assignments.length < 1 ? (
          <Text textTransform={"capitalize"} textAlign={"center"}>No Uploaded Assignments</Text>
        ) : assignments.map((assignment, index) => (
          <Flex key={assignment.assignment_id} bgColor={"brand.white"} flexDirection={"column"} m={4} borderRadius={"20px"} p={6} justifyContent="space-between">
            <Text textTransform={"capitalize"} fontWeight={"extrabold"} textAlign="center"
              fontSize={"lg"}>{assignment.course_name}</Text>
            <Text textTransform={"capitalize"} fontWeight={"extrabold"} textAlign="center"
              fontSize={"sm"} mb={2}>{assignment.teacher_username}</Text>
            <Link href={assignment.assignment_link} download>
              <Image
                title={"document"}
                src={Doc}
                alt={"document icon"}
                boxSize={"30px"}
                mr={1}
                my={1}
                d={"inline-block"}
              />
              {assignment.course_name}
            </Link>
            <Flex justifyContent={"space-between"}>
              <Text color={"grey.400"} p={1} textAlign={"center"}>{assignment.assignment_grade} marks</Text>
              <Text color={"grey.400"} p={1} textAlign={"center"}>due {assignment.assignment_due_date}</Text>
            </Flex>
            <Link as={NavLink} to={`/student/assignments/submit-assignments/${assignment.assignment_id}`}
              bgColor="brand.lightGreen" fontWeight="semibold" textAlign="center" w="70px" p={1}
              borderRadius="15px" _hover={{ textDecoration: "none" }}>
              submit
            </Link>
          </Flex>
        ))}
      </Grid>
    </Flex>
  );
}

export default Assignments;